import React from 'react';

// eslint-disable-next-line react/function-component-definition
export default function ThumbUpOutline() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.57 6.667v3.666L16.495 17.5H6.238V6.817L12.212.833l1.367 1.35-.934 4.484h6.925zm-11.666.841v8.325h7.492l2.508-5.841V8.333h-7.309l.925-4.45-3.616 3.625z"
        clipRule="evenodd"
      />
      <path fill="currentColor" d="M4.57 17.5H1.237v-10H4.57v10z" />
    </svg>
  );
}
